<template lang="pug">
.total_wrap
  #wrap_sub
    .sub_left
    .sub_right
      .content_title
      .content_desc
        #s11
          .in
            .s11_a.sub
              h2.s_tit
                span 인사말
              .cont
                .ceo
                  .img
                  .txt
                    h3(data-aos='fade-down')
                      | 모든 맥주 회사들이 저마다 신선한 맛을 강조하고 있습니다. 
                      br
                      | 그러나 가장 신선한 맥주를 맛볼 수 있는 유일한 방법은 
                      br
                      span.yell.bold ‘맥주 양조장에서 갓 만들어진 맥주를 그 자리에서 바로 마시는 것’
                      | 이 
                      span.yell.bold Fact
                      | 입니다.
                    p(data-aos='fade-down' data-aos-delay='200')
                      span 인더케그의 사업은 갓 만든 맥주의 ‘신선한 맛’을 그대로 유지한 상태로 소비자가 즐길 수 있는 솔루션을 개발해보겠다는 배경에서 시작되었습니다. Smart Brewery Platform은 스마트케그 안의 맥즙을 맥주로 제조해주는 인더케그 기기를 통해 누구라도 신선한 맥주를 제조(발효/숙성/보관) 후 10가지 다른 종류의 18리터 맥주를 판매할 수 있는 솔루션입니다.
                      span 단순히 ‘쉽게 맥주를 만들어 팔 수 있다’는 것을 넘어서, ‘갓 만들어진 맥주를 가장 신선하고 다양하게 즐길 수 있다’는 것이 핵심 고객 가치입니다. 인더케그 기기는 맥주맛 변질 가능성을 최소화하여 오랫동안 맥주맛을 유지할 수 있고 설치된 그 자리에서 바로 맥주 제공이 가능하므로 별도의 유통과정도 필요하지 않습니다.
                      span 즉, 인더케그 기기 자체가 맥주 양조장입니다.
                      span Smart Brewery Platform을 통해 양조장에서 갓 만든 맥주 맛의 가치를 여러분들께서  제공할 수 있기를 바랍니다.
                      span 감사합니다.
                    h4(data-aos='fade-down' data-aos-delay='100') 인더케그 임직원 일동
                .info
                  .info1.info_list(data-aos='fade-right')
                    h3 본사
                    h4
                      | 14056
                      br
                      | 경기도 안양시 동안구 학의로 282
                      br
                      | 8층 827호 (관양동, 금강펜테리움IT타워)
                    ul
                      li
                        h5 TEL.
                        p +82-31-423-3642
                      li
                        h5 FAX.
                        p +82-31-426-4907
                      li.email
                        h5 E-MAIL.
                        p info@inthekeg.com
                  .info2.info_list(data-aos='fade-right' data-aos-delay='200')
                    h3 공장
                    h4
                      | 54004 
                      br
                      | 전북 군산시 자유로 233-115
                    ul
                      li
                        h5 TEL.
                        p +82-63-466-0564
                  .info3.info_list(data-aos='fade-right' data-aos-delay='400')
                    h3 R&D센터
                    h4
                      | 16079 
                      br
                      | 경기 의왕시 오봉산단3로 25 (삼동)
                      br
                      | 더리브 비즈원지식산업센터 5층
            .s11_b.sub
              h2.s_tit
                span 연혁
              .cont
                .img_wrap
                  .img
                  .history
                    .year(v-for="year in history.year" :key="year")
                      .lt(data-aos="fade-right")
                        h3 {{year}}
                      .md(data-aos='fade-right' data-aos-delay='100')
                        span
                      .rg(data-aos='fade-right' data-aos-delay='200')
                        ul
                          li(v-for="(month, index) in setMonth(year)" :key="index")
                            h4 {{month}}
                            .h_con
                              p(v-for="(text, idx) in setContent(year, month)" :key="idx") {{text}}
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      history: {},
    };
  },
  computed: {
    ...mapGetters(['lan']),
  },
  methods: {
    getData() {
      this.$_axios('GET', 'board/content/history', { nation: this.lan }).then(
        res => {
          this.history = res.data.res[0];
        },
      );
    },
    setMonth(year) {
      let date = this.history.date;
      let result = [];
      date.forEach((e, i) => {
        if (e.includes(year)) {
          result.push(e.split('-')[1]);
        }
      });
      return result;
    },
    setContent(year, month) {
      let content = this.history.content;
      let result = [];
      let date = `${year}-${month}`;
      content.forEach((e, i) => {
        if (e[date]) {
          result = e[date];
        }
      });
      return result;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped></style>
